import React, { forwardRef } from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default withTranslation()(function ReportRowActions({ t, report, onDownload, onDelete }) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => onDownload(report)}
        className="w-9 h-9 flex items-center justify-center rounded-full border border-border-lines hover:bg-background"
      >
        <UIcons.UilImport size={18} className="text-dark-blue" />
      </button>

      <ClickAwayComponent
        Component={forwardRef(({ handleClick, open }, ref) => (
          <div className="relative" ref={ref}>
            <button
              type="button"
              onClick={handleClick}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-border-lines hover:bg-background"
            >
              <UIcons.UilEllipsisV size={18} className="text-dark-blue" />
            </button>

            {
              open && (
                <div className="absolute right-0 top-10 z-20 w-40 bg-white border border-border-lines rounded-xl shadow-lg py-2">
                  <button
                    type="button"
                    onClick={() => { onDownload(report); handleClick() }}
                    className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-dark-blue hover:bg-background"
                  >
                    <UIcons.UilImport size={16} /> {t('reports.recent.download')}
                  </button>

                  <button
                    type="button"
                    onClick={() => { onDelete(report); handleClick() }}
                    className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-danger hover:bg-background"
                  >
                    <UIcons.UilTrashAlt size={16} /> {t('reports.recent.delete')}
                  </button>
                </div>
              )
            }
          </div>
        ))}
      />
    </div>
  )
})
